module.exports = __webpack_public_path__ + "static/img/ISO27001.bde02b46.png";